import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Flex } from 'rebass/styled-components';

import { layout } from '../../constants/constants';
import SecondaryNav from '../../shared/components/secondary-nav/secondary-nav';
import ShLink from '../../shared/components/sh-link/sh-link';
import SocialMediaButtons from '../../shared/components/social-media-buttons/social-media-buttons';
import { Media } from '../../shared/contexts/media/MediaContext';
import { UiStateContext } from '../../shared/contexts/ui-state/UiStateContext';
import useColumnEnd from '../../shared/hooks/column-end/useColumnEnd';
import { GlobalFooterContent, SecondaryNavContent } from '../../shared/models/app-data-model';
import './global-footer-desktop.scss';

export type GlobalFooterDesktopProps = {
  content: GlobalFooterContent;
};

const GlobalFooterDesktop: React.FC<GlobalFooterDesktopProps> = ({ content }: GlobalFooterDesktopProps) => {
  const uiStateContext = useContext(UiStateContext);

  const [firstTabData] = useState(
    // find the first tab, which should be the first footer_nav
    content?.footer_nav
      ?.find((navItem) => navItem?.primary_nav_item?.reference.find((el) => el.footer_nav))
      ?.primary_nav_item.reference.find((el) => el.footer_nav)?.footer_nav
  );
  const [selectedTabData, setSelectedTabData] = useState(firstTabData ? firstTabData : ([] as SecondaryNavContent[]));
  const [footerColumns, setFooterColumns] = useColumnEnd(selectedTabData);

  // This hook is responsible for updating our column-end hook whenever our content changes
  useEffect(() => {
    setFooterColumns(selectedTabData);
  }, [selectedTabData, setFooterColumns]);
  const selectTab = useCallback(
    (tabIndex: number, tabData: SecondaryNavContent[]): void => {
      uiStateContext?.setSelectedFooterItem?.(tabIndex);
      setSelectedTabData(tabData);
    },
    [uiStateContext]
  );

  return (
    <Media greaterThanOrEqual="desktop">
      {!uiStateContext.auxNavOpen && (
        <div className="global-footer-desktop">
          <div className="global-footer-desktop-heading-container">
            <Flex className="global-footer-desktop-heading" width={layout.pageWidth} px={layout.pagePaddingX} mx={'auto'}>
              <div className="global-footer-desktop-tabs">
                {content?.footer_nav?.map((item, index) => {
                  const itemWithChildren = item.primary_nav_item?.reference.find((el) => el.footer_nav);
                  const itemWithLink = item.primary_nav_item?.reference.find((el) => el.url || el.link);
                  const itemSelectedClass =
                    (!uiStateContext?.selectedFooterItem && index === 0) || uiStateContext?.selectedFooterItem === index ? 'open' : '';
                  if (itemWithChildren) {
                    return (
                      <button
                        className={`primary-nav-item unstyled-btn ${itemSelectedClass}`}
                        onClick={() => {
                          selectTab(index, itemWithChildren.footer_nav as SecondaryNavContent[]);
                        }}
                        key={index}
                      >
                        {item.primary_nav_item.title}
                      </button>
                    );
                  } else if (itemWithLink) {
                    return (
                      <ShLink
                        title={item.primary_nav_item.title}
                        className="primary-nav-item"
                        reference={item.primary_nav_item.reference}
                        key={index}
                      />
                    );
                  }
                })}
              </div>
              <div className="global-footer-desktop-social-media">
                <SocialMediaButtons socials={content.social_media_links} className="primary-nav-item" />
              </div>
            </Flex>
          </div>

          {footerColumns && <SecondaryNav columns={footerColumns} />}
        </div>
      )}
    </Media>
  );
};

export default GlobalFooterDesktop;
